export default {
    checkout: {
      started: 'Let’s get started',
      extra: 'Choose your extras',
      almost_there:'You’re almost there!',
      signin_google:'Sign In using Google',
      signin_chenosis: 'Sign In using',
      or:'OR',
      login:'Login',
      email: 'Your email',
      password: 'Your password',
      password_confirmation: 'Confirm your password',
      tip_email_verification: 'Email verification is mandatory for the provided email address.',
      welcome: 'Welcome back',
      login_as: 'You are logged in as',
      not: 'Not',
      sign_out: 'Sign Out',
      sign_up_google: 'Sign Up using Google',
      sign_up_chenosis: 'Sign Up using',
      sign_up: 'Sign Up',
      first_name: 'Your first name',
      last_name: 'Your last name',
      email_registered: 'Your email address is already registered!',
      pick_another: 'or pick another one.',
      business: 'Are you a business?',
      company: 'Your company name',
      station_name: 'Tell us about your station.',
      station: 'Station name',
      website: 'Website URL (optional)',
      choose_extras: 'Choose extras (optional)',
      one_time: 'One time',
      add_this: 'Add This',
      disclaimer_google: '(Disclaimer: Google Play account required $30 one time fee)',
      included: 'Included',
      disclaimer_apple: '(Disclaimer: App Store account required $100 per year fee)',
      two_month_free: 'Get 2 months free!',
      annually_discount: 'Pay your subscription annually and get 12 months service for the price of 10!',
      pay_annually: 'Pay Annually',
      chose_annual_pay: 'You have chosen to pay for your station annually.',
      charge_after_trial: ' will be charged after your trial ends. If you\'d prefer to pay monthly, please click',
      here: 'here',
      no_charging: '. Don’t worry, you will not be charged anything today. Easily cancel or upgrade/downgrade your plan at any time.',
      then_charge: 'then you will be charged',
      trial_ends: 'Your 7 day trial lasts until midnight on',
      per: 'per',
      few_mention: 'Just a few things to mention.',
      policy: 'Details about how we use the information you have provided can be found in our Terms and Privacy Policy. Please state you have read both documents and agree to these terms before proceeding. You must accept these terms before using our service.',
      confirm: 'I confirm I have read and agree to the',
      agreement: 'Privacy Agreement',
      required: 'This field is required',
      back: 'Back',
      step: 'Step',
      next: 'Next',
      select_plan: 'Selected Plan',
      storage:' Storage',
      listeners:' Listeners',
      bandwidth:' Bandwidth',
      users:' Users',
      return:'Return to pricing and plans',
      your_extras:'Your Extras',
      processing:'Processing',
      start_trial:'Start Free Trial',
    },
  };